var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup5796(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5796",
    "data-name": "Group 5796",
    transform: "translate(0 0)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "panchagam",
    transform: "translate(-328.6 -205.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9719",
    "data-name": "Path 9719",
    d: "M388.745,251.895a13.274,13.274,0,1,1-13.476-13.2A13.247,13.247,0,0,1,388.745,251.895Zm-4.424.383a8.939,8.939,0,0,0-17.878.023,8.939,8.939,0,1,0,17.878-.023Z",
    transform: "translate(-26.872 -26.793)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9720",
    "data-name": "Path 9720",
    d: "M410.2,210.566c.681-1.722,1.361-3.424,2.142-5.366.761,1.922,1.442,3.624,2.142,5.366Z",
    transform: "translate(-63.764)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9721",
    "data-name": "Path 9721",
    d: "M355.6,232.3c1.922.821,3.624,1.542,5.165,2.222-.981.961-1.942,1.942-2.963,2.943C357.162,235.944,356.441,234.242,355.6,232.3Z",
    transform: "translate(-21.594 -21.674)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9722",
    "data-name": "Path 9722",
    d: "M463.523,237.386c-1-1-1.942-1.962-2.923-2.963,1.5-.641,3.183-1.381,5.125-2.222C464.9,234.142,464.2,235.824,463.523,237.386Z",
    transform: "translate(-102.571 -21.594)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9723",
    "data-name": "Path 9723",
    d: "M355.6,342.525c.841-1.962,1.562-3.644,2.2-5.125.941.981,1.922,1.962,2.883,2.943C359.244,340.944,357.562,341.685,355.6,342.525Z",
    transform: "translate(-21.594 -102.751)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M460.9,340.423c.981-.981,1.942-1.962,2.9-2.923.621,1.462,1.361,3.163,2.182,5.105C464.063,341.765,462.382,341.064,460.9,340.423Z",
    transform: "translate(-102.811 -102.831)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9725",
    "data-name": "Path 9725",
    d: "M412.362,368.586c-.781-1.942-1.462-3.624-2.162-5.386h4.285C413.8,364.9,413.143,366.6,412.362,368.586Z",
    transform: "translate(-63.764 -123.386)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9726",
    "data-name": "Path 9726",
    d: "M333.966,286.9v4.3c-1.722-.681-3.424-1.361-5.366-2.142C330.542,288.261,332.244,287.581,333.966,286.9Z",
    transform: "translate(0 -63.852)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9727",
    "data-name": "Path 9727",
    d: "M486.5,291.285V287c1.722.681,3.424,1.361,5.386,2.142C489.944,289.9,488.242,290.584,486.5,291.285Z",
    transform: "translate(-123.286 -63.931)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9728",
    "data-name": "Path 9728",
    d: "M440.2,215.9v5.045c-1.321-.541-2.563-1.061-3.9-1.622C437.681,218.122,439.063,216.9,440.2,215.9Z",
    transform: "translate(-84.182 -8.558)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9729",
    "data-name": "Path 9729",
    d: "M338.9,262.7h5.125c-.561,1.341-1.061,2.583-1.6,3.864C341.182,265.223,339.941,263.861,338.9,262.7Z",
    transform: "translate(-8.238 -44.953)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9730",
    "data-name": "Path 9730",
    d: "M477.4,262.8h5.346c-1.161,1.221-2.423,2.543-3.724,3.9C478.5,265.4,477.961,264.141,477.4,262.8Z",
    transform: "translate(-116.008 -45.03)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9731",
    "data-name": "Path 9731",
    d: "M436,355.822c1.361-.561,2.583-1.081,3.924-1.622v5.266C438.723,358.364,437.381,357.123,436,355.822Z",
    transform: "translate(-83.946 -116.188)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M386,220.146V214.9c1.261,1.161,2.583,2.383,3.924,3.624C388.623,219.064,387.381,219.585,386,220.146Z",
    transform: "translate(-44.865 -7.758)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9733",
    "data-name": "Path 9733",
    d: "M343.046,316.5H337.7c1.141-1.241,2.383-2.583,3.684-4C341.965,313.881,342.465,315.1,343.046,316.5Z",
    transform: "translate(-7.278 -83.878)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    d: "M386.1,354.1c1.341.561,2.583,1.081,3.944,1.642-1.381,1.241-2.743,2.463-3.944,3.524Z",
    transform: "translate(-44.943 -116.108)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    d: "M477.6,316.784c.561-1.341,1.061-2.563,1.6-3.884,1.241,1.381,2.463,2.763,3.464,3.884Z",
    transform: "translate(-116.168 -84.197)",
    fill: "#ffc160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9736",
    "data-name": "Path 9736",
    d: "M393.907,265.4a6.711,6.711,0,1,0,6.707,6.707,6.824,6.824,0,0,0-.9-3.364,6.756,6.756,0,0,0-2.463-2.463,6.887,6.887,0,0,0-3.344-.881Zm2.643,9.971-2.943-2.943a.407.407,0,0,1-.12-.3v-4.2h.841v4.024l2.823,2.823Z",
    transform: "translate(-45.375 -46.625)",
    fill: "#ffc160"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5796);
export default __webpack_public_path__ + "static/media/Group 5796.4d0e63fb5f539a3874c19db37bec5d7d.svg";
export { ForwardRef as ReactComponent };